import { registerSuperProperties, setPeopleProperty } from '@Services/analytics/tracking.service';
import { HttpService } from '@Services/api/httpService';
import { useBoundStore } from '@Store/index';

const isProdMode = import.meta.env.VITE_RAINGUARD_ENABLED === 'true';

const KITE_BACKEND_URL = 'https://kite-li.preprod.rainguard.ai';

export const initRainguard = (): void => {
  if (!isProdMode) return;
  // eslint-disable-next-line import/no-unresolved
  import('kite_sdk')
    .then(({ init }) => {
      init(KITE_BACKEND_URL);
    })
    .catch((e) => {
      console.warn('Kite SDK failed to load', e);
    });
};

export const evaluateRainguard = async (): Promise<void> => {
  if (!isProdMode) return;

  try {
    // eslint-disable-next-line import/no-unresolved
    const { collect } = await import('kite_sdk');
    const result = await collect();
    console.log('Kite SDK collected', result);

    if (!result) return;

    const props = {
      kiteToken: result.token,
      kiteState: result.state,
    };
    setPeopleProperty(props);
    registerSuperProperties(props);

    const customerId = useBoundStore.getState().customer.customerId;
    if (customerId) {
      HttpService.post(`v1/user/security/${customerId}/kite/evaluate`, {
        token: result.token,
        state: result.state,
      }).catch((e) => {
        console.warn('Kite evaluate request failed', e);
      });
    }
  } catch {
    const props = {
      kiteToken: null,
      kiteState: 'collect_failed',
    };
    setPeopleProperty(props);
    registerSuperProperties(props);
  }
};
